import React from 'react';
import './PC.css';
import Adobe from '../../img/pc/Adobe.png'
import Anderson from '../../img/pc/Anderson.png'
import LinkedIn from '../../img/pc/LinkedIn.png'
import Cloudinary from '../../img/pc/Cloudinary.png'
import Fayock from '../../img/pc/Fayock.png'
import Goncharov from '../../img/pc/Goncharov.png'
import HM from '../../img/pc/HM.png'
import Kaufman from '../../img/pc/Kaufman.png'
import m4dz from '../../img/pc/m4dz.png'
import next from '../../img/pc/next.png'
import PayPal from '../../img/pc/PayPal.png'
import RIOTS from '../../img/pc/RIOTS.png'
import Salnikov from '../../img/pc/Salnikov.png'
import samsung from '../../img/pc/samsung.png'
import Subramanian from '../../img/pc/Subramanian.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      speakers: [
        {
          photo: Anderson,
          name: 'Devon Anderson',
          position: 'Staff Software Engineer',
          ln: 'https://linkedin.com/in/devonwtanderson/',
          tw: 'https://twitter.com/devonwtanderson',
          logo: LinkedIn,
        },
        {
          photo: Goncharov,
          name: 'Andrey Goncharov',
          position: 'Software Engineer',
          tw: 'https://twitter.com/ai_goncharov',
          github: 'https://github.com/aigoncharov',
          website: 'https://goncharov.page/',
          logo: samsung,
        },
        {
          photo: Kaufman,
          name: 'Nir Kaufman',
          position: 'Frontend Tech Lead',
          website: 'https://nir.life/',
          logo: next,
        },
        {
          photo: HM,
          name: 'Hemanth HM',
          position: 'Engineering Manager',
          website: 'https://h3manth.com/',
          logo: PayPal,
        },
        {
          photo: Salnikov,
          name: 'Maxim Salnikov',
          position: 'Senior Developer Engagement Lead',
          tw: 'https://twitter.com/webmaxru',
        },
        {
          photo: m4dz,
          name: 'm4dz 🎙🥑',
          position: 'Frontend Devtools Advocate',
          ln: 'https://www.linkedin.com/in/m4d-z/',
          tw: 'https://twitter.com/m4d_z',
          github: 'https://github.com/m4dz/',
          logo: RIOTS,
        },
        // {
        //   photo: Subramanian,
        //   name: 'Deepa Subramanian',
        //   position: 'QE Developer',
        //   tw: 'https://twitter.com/sdk_deepa',
        //   logo: Adobe,
        // },
        // {
        //   photo: Fayock,
        //   name: 'Colby Fayock',
        //   position: 'Senior Developer Experience Engineer',
        //   ln: 'https://www.linkedin.com/in/colbyfayock/',
        //   tw: 'https://twitter.com/colbyfayock',
        //   // github: 'https://github.com/colbyfayock',
        //   youtube: 'https://youtube.com/colbyfayock',
        //   logo: Cloudinary,
        // },
        // {
        //   photo: Barthwal,
        //   name: 'Nikhil Barthwal',
        //   position: 'Sr. Software Engineer',
        //   tw: 'https://twitter.com/nikhilbarthwal',
        //   website: 'http://www.nikhilbarthwal.com',
        //   logo: facebook,
        // },
      ],
      isHovered: false,
      hoveredPC: [],
    }
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handleMouseEnter = (name) => {
    this.setState({ isHovered: true })
    if (this.state.hoveredPC.indexOf(name) > -1) {
      let index = this.state.hoveredPC.indexOf(name);
      if (index !== -1) {
        this.setState({
          hoveredPC: this.state.hoveredPC.filter(function (item) {
            return item !== name
          })
        });
      }
    } else {
      this.setState({ hoveredPC: [...this.state.hoveredPC, name] })
    }
  };

  handleMouseLeave = () => {
    this.setState({ isHovered: false })
    this.setState({ hoveredPC: [] });
  };

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className='pc_info' style={{ backgroundImage: `url(${item.photo}` }}>
          <p className="pc_name p1">{item.name}</p>
          <p className="pc_position p2 grey">{item.position}</p>
          <img className='pc_logo' src={item.logo} alt="" />
          <div className="pc_links">
            {item.fb && <a className="social_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="social_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="social_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="social_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="social_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.youtube && <a className="social_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
            {item.twitch && <a className="social_link social_twitch" target='_blank' rel="noreferrer" href={item.twitch}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="pc_wrap pc_wrap--mb" id='speakers'>
        <div className='container pc'>
          <h2 className='pc_title pc_main'>Speakers from previous event</h2>
          <div className='pc_block'>
            {this.state.speakers.map((item, i) => this.renderPC(item, i))}
          </div>
        </div>
      </div>
    )
  }
}